import { ref, type Ref } from 'vue'

export const useMinimumLoading = (sourceLoading: Ref<boolean>, minimumMs = 500) => {
  const isLoading = ref(sourceLoading.value)

  let startTime = 0
  let timeoutId: Maybe<NodeJS.Timeout> = null

  watchImmediate(sourceLoading, (newValue) => {
    if (newValue) {
      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
      }

      startTime = Date.now()
      isLoading.value = true
      return
    }

    const elapsed = Date.now() - startTime
    const remaining = minimumMs - elapsed

    if (remaining <= 0) {
      isLoading.value = false
      return
    }

    timeoutId = setTimeout(() => {
      isLoading.value = false
      timeoutId = null
    }, remaining)
  })

  return isLoading
}
